import React, { useEffect, useState, useRef } from 'react';
 import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4'; 

const dateStockData = async (parms) => {
  const response = await fetch(`${process.env.REACT_APP_URL_FPS}/fps/DateWiseStockSchemewise`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(parms),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
};

const DateWise_StockdetailsSchemeWise = ({ month, year, comm_id,  pos_ob_date,fps_id}) => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const fpscardstab = useRef(null); // Use ref to scroll to this div
  const [totals, setTotals] = useState([]); 
  
  const calculateTotals = (data) => {
    const columnCount = data[0].lst.length;
    const columnTotals = new Array(columnCount).fill(0); // Initialize an array for totals

    data.forEach(item => {
        item.lst.forEach((colItem, colIndex) => {
            columnTotals[colIndex] += parseFloat(colItem.qty_1) || 0; // Sum each column's allot_qty
        });
    });
    setTotals(columnTotals); 
};

  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await dateStockData({  month, year, comm_id,  pos_ob_date,fps_id });
        setTabHeading(response_data.heading);
        if (response_data.data && response_data.data.length > 0) {
          setReportData(response_data.data);
          //calculateTotals(response_data.data); 

        } else {
          setReportData([]);
        }
      } catch (errorr) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [ month, year, comm_id,  pos_ob_date,fps_id]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
    setPage(0); // Reset page to 0 when changing rows per page
  };


  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && fpscardstab.current) {
      fpscardstab.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [loading, error, reportData]);


  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }
  if (error) {
    return <div className="mainhead" align="center">Internal Error</div>;
  }
  if (reportData.length === 0) {
    return <div className="mainhead" align="center">No data found</div>;
  }

  // Pagination logic
  const paginatedData = rowsPerPage === 'all' 
    ? reportData 
    : reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <table  align="center" width="80%" border={1}>
        <thead>
          <tr className="tableheader">
            <th colSpan={9}>{tabHeading}</th>
          </tr>
          <tr className="tableheader">
           <th>Sl.No</th>
            <th>Scheme</th>
            <th>Units</th>
            <th>OB Qty  <br /><span className="styleDF">(A) </span> </th>
            <th>Received Qty <br /><span className="styleDF">(B)</span>  </th>
            <th>Extra <br /><span className="styleDF">(C)</span> </th>

            <th>Moved <br /><span className="styleDF">(D)</span> </th>
            <th>Issued Qty <br /><span className="styleDF">(E)</span>  </th>
            <th>CB Qty <br /><span className="styleDF"> (A+B+C+D-E)   </span> </th>
          </tr>
         
        </thead>
        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={item.fps_id}>
              <td style={{ textAlign: 'center' }}>{rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}</td> {/* Adjusted Sl.No */}
              <td style={{ textAlign: "left" }}>
              {item.scheme_name_en}
              </td>

              <td style={{ textAlign: "left" }}>{item.comm_measure_unit}</td>
              <td style={{ textAlign: "right" }}>{item.ob}</td>
              <td style={{ textAlign: "right" }}>{item.received_qty}</td>
                            <td style={{ textAlign: "right" }}>{item.extra_ro}</td>

              <td style={{ textAlign: "right" }}>{item.sixa_case}</td>
              <td style={{ textAlign: "right" }}>{item.issued_qty}</td>
              <td style={{ textAlign: "right" }}>{item.cb}</td>
            </tr>
          ))}

             <tr className="tableheader">
                        <td colSpan={17} style={{ textAlign: 'right' }}>
                            Data Time:
                            <font style={{color:'red'}}> 
                                 {reportData[0]?.data_time?.substring(0, 16)}
                                 </font>
                        </td>
                    </tr>


        </tbody>
        
       
      </table>
      <br /><br />
      {/* <div width="75%" style={{display:'flex', justifyContent:'right',alignItems:'start' , width:'95%'}}> 
      <PaginationTable
        count={reportData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /></div> */}
       <br /><br /> <br /><br />
    </>
  );
};

export default DateWise_StockdetailsSchemeWise;
